import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../../helpers/pagination';
import {
  portalUsersOnClear,
  portalUsersOnChangePage,
  portalUsersOnChangeOrder
} from '../../../actions/portal/user';
import { fetchPortalUsers } from '../../../sagas/portal/routines';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'createdAt:desc'
};

const portalUsersOnClearHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const portalUsersOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const portalUsersOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchPortalUsers),
  ...portalUsersOnClearHandler(portalUsersOnClear),
  ...portalUsersOnChangePageHandler(portalUsersOnChangePage),
  ...portalUsersOnChangeOrderHandler(portalUsersOnChangeOrder)
});
